module.exports = __webpack_public_path__ + "img/1248086475.e6f1ab5c.jpg";